import Component from './component'
import {connect} from 'react-redux'
import {login} from '../../actions/sistema'
import { showSnack } from 'react-redux-snackbar';

const dis = (dispatch) => ({
    login : (usuario, senha) => dispatch(login(usuario, senha)),
    feedback : (message) => dispatch(showSnack(Date.now(), {
        label : message,
        timeout : 5000,
        button : {label : 'Beleza'}
    }))
})

const st = (state) => ({
    algoErrado : state.ui.login.get('algoErrado'),
    algoCerto : state.ui.login.get('usuario')!==undefined
})

export default connect(st, dis)(Component)


// WEBPACK FOOTER //
// ./src/views/login/container.js